import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IELTVersionsCount } from 'legacy/lut/classes/models/partner360/ELT/IELTVersionsCount'
import { getFetchDataFilter } from 'legacy/lut/classes/services/EltStoreService'

import { CrudStore } from 'core/types/crudStore'

interface IGetVersionsCount {
  groupId: number | null
  partnerId: string | null
}
export const getVersionsCount = async ({ groupId, partnerId }: IGetVersionsCount) => {
  const crud = CrudStore.get<IELTVersionsCount>(CrudStoreItemPartner360.JBPELTVersionsCount)
  crud.setFilter(getFetchDataFilter(partnerId, groupId))
  crud.setPaging({ page: 0, pageSize: 1 })
  const res = await crud.fetch()
  return res?.items[0]?.VCount
}
